import React from 'react';
import PropTypes from 'prop-types';
const uuid = require('uuid');
const Moment = require('moment');

const _ = {
    findIndex:  require('lodash/findIndex'),
    find:       require('lodash/find'),
    filter:     require('lodash/filter'),
    forEach:    require('lodash/forEach'),
};


const ShortCourseInstanceStore = require('../../stores/ShortCourseInstanceStore');
const ShortCourseInstanceActions = require('../../actions/ShortCourseInstanceActions');
const ShortCourseStore = require('../../stores/ShortCourseStore');
const ShortCourseActions = require('../../actions/ShortCourseActions');
const ShortCoursePlayStore = require('../../stores/ShortCoursePlayStore');
const GlobalUserStore = require('../../stores/GlobalUserStore');
const GlobalUserActions = require('../../actions/GlobalUserActions');

const Globals = require('../../../../app/globals');
const Strings = require('../../../../app/shared/Strings');
const ShortCourseUtil = require('../../../../app/shared/ShortCourseUtil');

const AssetUtil = require('../../util/asset');
const KeyboardUtil = require('../../util/keyboard');

import TileListEmpty from '../tiles/TileListEmpty';
import SortableTableClassic from '../table/SortableTableClassic';
import ErrorBox from '../common/ErrorBox';
import ActionHistoryPanel from './ActionHistoryPanel';

const propTypes = {
    userInfo: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        display_name: PropTypes.string.isRequired,
    }).isRequired,
    className: PropTypes.string,
};
const defaultProps = {
    className: '',
};

const HISTORY_DATE_FORMAT = 'MM/DD/YYYY HH:mm';

class StudentHome extends React.Component {
    constructor(props) {
        super(props);
        
        const stateFromStore = this.getStateFromStoreState(props,ShortCourseInstanceStore.getState());
        const lastLogin = GlobalUserStore.getLastLogin(props.userInfo.id);
        const userSummary = ShortCourseInstanceStore.getUserSummary(props.userInfo.id);
        
        this.state = {
            getActionId: null,
            getSummaryActionId: null, 
            lastLoginActionId: null,
            getError: null,
            lastLogin, 
            userSummary,
            ...stateFromStore
        };

        this.shortCourseInstClickHandler = this.shortCourseInstClickHandler.bind(this);
        this.unsubscribes = [
            ShortCourseInstanceStore.listen(this.onShortCourseInstanceStoreChange.bind(this)),
            GlobalUserStore.listen(this.onUserStoreChange),
        ];
    }

    componentDidMount() {
        let getActionId = null;
        let getSummaryActionId = null;
        let lastLoginActionId = null;
        if (!this.state.localShortCourses) {
            getActionId = uuid.v4();
        }
        if (!this.state.userSummary) {
            getSummaryActionId = uuid.v4();
        }
        if (!this.state.lastLogin) {
            lastLoginActionId = uuid.v4();
        }
        
        this.setState({ getActionId, getSummaryActionId, lastLoginActionId }, () => {
            if (getActionId) {
                ShortCourseInstanceActions.getMinimalCourseInstancesForUser(getActionId);
            }
            if(getSummaryActionId) {
                ShortCourseInstanceActions.getCourseInstanceSummariesForUser(getSummaryActionId);
            }
            if (lastLoginActionId) {
                GlobalUserActions.getActionHistory(lastLoginActionId,{userId: this.props.userInfo.id, dayRange:Globals.user_actions.day_ranges.LAST_7_DAYS});
            }
        })
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }
    
    onUserStoreChange=(storeState)=>{
        if (storeState.action.id === this.state.lastLoginActionId) {
            const lastLogin = GlobalUserStore.getLastLogin(this.props.userInfo.id);
            this.setState({lastLogin,lastLoginActionId:null });
        }
    }
    
    getCourseOverallResult=(props,shortCourseInstance,instanceHash)=>{
        let progress = 0;
        if (shortCourseInstance) {
            const studentId = this.props.userInfo.id;
            let courseResult = ShortCourseUtil.getCourseOverallResult(shortCourseInstance, studentId, true);
            return courseResult;
        }
        else {
            console.log(`getCourseOverallResult: no doc for ${instanceHash}`);
            return {};
        }
    }
    
    getStateFromStoreState=(props,storeState,instanceDetails)=>{
        let localShortCourses;
        if (!instanceDetails) {
            instanceDetails = [];
        }
        if (storeState.intializedLocalMin) {
            localShortCourses = _.filter(
                storeState.minShortCourseInstances,
                { integration_type: Globals.integration_type.LOCAL, role_token: Globals.users.roles.STUDENT }
            );
            let detailChange = false;
            _.forEach(localShortCourses,(shortCourseInst) => {
                //if (shortCourseInst.course_complete) {
                //    return; // don't need details for completed courses
                //}
                const instanceHash = shortCourseInst.hash;
                let i = _.findIndex(instanceDetails,{instanceHash});
                let details = instanceDetails[i];
                const shortCourseInstance = ShortCourseInstanceStore.getStateShortCourseInstance(instanceHash).shortCourseInstance;
                if (!details) {
                    if (!shortCourseInstance) {
                        const actionId = uuid.v4();
                        ShortCourseInstanceActions.getShortCourseInstance(actionId,{instanceHash});
                        instanceDetails.push({actionId, instanceHash});
                        detailChange = true;
                    }
                    else {
                        // we have the doc so we don't need to request it.
                        instanceDetails.push({
                            actionId: null,
                            instanceHash,
                            gotResult: true,
                            courseResult: this.getCourseOverallResult(props,shortCourseInstance,instanceHash),
                        });
                        detailChange = true;
                    }
                }
                else {
                    if (storeState.action.id === details.actionId) {
                        instanceDetails[i] = {...details, 
                            actionId: null, 
                            gotResult: true,
                            courseResult: this.getCourseOverallResult(props,shortCourseInstance,instanceHash),
                        };
                        detailChange = true;
                    }
                }
            });
            if (detailChange) {
                instanceDetails = instanceDetails.slice(); // so react knows there was a change
            }
        }
        const userSummary = ShortCourseInstanceStore.getUserSummary(this.props.userInfo.id);

        return { localShortCourses, instanceDetails, userSummary };
    }

    onShortCourseInstanceStoreChange(storeState) {
        let additionalState = {};
        if (storeState.action.id === this.state.getActionId) {
            if (!storeState.action.error) {
                additionalState = {
                    ...additionalState,
                    getActionId: null,
                };
            }
            else {
                additionalState = {
                    ...additionalState,
                    getActionId: null,
                    getError: storeState.action.error,
                };
            }
        }
        let getSummaryActionId = this.state.getSummaryActionId;
        if (storeState.action.id === getSummaryActionId) {
            getSummaryActionId = null;
        
        }        
        let lastLoginActionId = this.state.lastLoginActionId;
        if (storeState.action.id === lastLoginActionId) {
            lastLoginActionId = null;
        }

        const stateFromStore = this.getStateFromStoreState(this.props,storeState, this.state.instanceDetails);
        this.setState({
            ...stateFromStore,
            ...additionalState,
            getSummaryActionId, 
            lastLoginActionId,
        });
    }

    shortCourseInstClickHandler(e, hash) {
        window.location.href = `/course_instance/${hash}`;
    }

    render() {
        let currentCourses =  [];
        let completedCourses =  [];
        let grandTotalStars;

        const localShortCourses = this.state.localShortCourses;
        if (localShortCourses) {
            grandTotalStars = 0;
            if (localShortCourses.length) {
                _.forEach(localShortCourses,(shortCourseInst) => {
                    let key = shortCourseInst.hash;
                    let courseImg = (<div className="course-img"></div>); // Temp until we get a default course image
                    if (shortCourseInst.course_image_url) {
                        courseImg = (<img className="course-img" src={AssetUtil.resolveAssetPath(shortCourseInst.course_image_url)} alt=" " aria-hidden />);
                    }

                    let details = _.find(this.state.instanceDetails,{instanceHash:key});
                    if (details && details.courseResult) {
                        grandTotalStars += details.courseResult.total_stars;
                    }

                    if (shortCourseInst.course_complete) {
                        completedCourses.push(
                            <div
                                key={key}
                                className="course-tile course-tile-interactable"
                                tabIndex="0"
                                onClick={(e)=>{this.shortCourseInstClickHandler(e, key)}}
                                onKeyDown={(e)=>{if (KeyboardUtil.isSelectKey(e.keyCode)) this.shortCourseInstClickHandler(e, key)}}
                            >
                                {courseImg}
                                <div className="course-info">
                                    <span className="course-title">{shortCourseInst.name}</span>
                                </div>
                                <img
                                    className="completed-ribbon"
                                    src={`${GlobalConfig.StaticUrl}/img/courses/ribbon.svg`}
                                    alt={Strings['en'].short_course_instance.user_status.COMPLETE}
                                />
                            </div>
                        );
                    }
                    else {
                        let progressStyle = {};
                        let stars='N';
                        let total_stars='A';
                        let progressTitle = "progress";
                        if (details && details.courseResult) {
                            progressStyle = { width: `${details.courseResult.progress}%` };
                            progressTitle = `${details.courseResult.progress}% complete`
                            stars = details.courseResult.stars;
                            total_stars = details.courseResult.total_stars;
                        }
                        
                        currentCourses.push(
                            <div
                                key={key}
                                className="course-tile course-tile-interactable"
                                tabIndex="0"
                                onClick={(e)=>{this.shortCourseInstClickHandler(e, key)}}
                                onKeyDown={(e)=>{if (KeyboardUtil.isSelectKey(e.keyCode)) this.shortCourseInstClickHandler(e, key)}}
                            >
                                {courseImg}
                                <div className="course-info">
                                    <span className="course-title">{shortCourseInst.name}</span>
                                    <div className="course-progress-bg" title={progressTitle}>
                                        <div className="course-progress" style={progressStyle}>
                                        </div>
                                    </div>
                                    <div className="bottom-row">
                                        <div className="sub-skills-counter">
                                            <span className="ss-frac">{`${stars}/${total_stars}`}</span>
                                            <span className="ss-label">{Strings['en'].dashboard.SUB_SKILLS}</span>
                                        </div>
                                        <span className="course-arrow"></span>
                                    </div>
                                </div>
                            </div>
                        );
                    }
                });

                if (completedCourses.length === 0) {
                    completedCourses = (
                        <TileListEmpty
                            promptVariant="small"
                            promptText={Strings['en'].short_course.skillbuild.NO_COMPLETED_COURSES_STUDENT}
                        />
                    );
                }
            }
            else {
                currentCourses = (
                    <TileListEmpty
                        promptVariant="small"
                        promptText={Strings['en'].short_course.skillbuild.NO_ACTIVE_COURSES_STUDENT}
                    />
                );
                completedCourses = (
                    <TileListEmpty
                        promptVariant="small"
                        promptText={Strings['en'].short_course.skillbuild.NO_COMPLETED_COURSES_STUDENT}
                    />
                );
            }
        }
        else if (this.state.getError) {
            //elems = (<ErrorBox error={this.state.getError} />);
        }
        else {
            currentCourses = ( <TileListEmpty promptText="Loading..."/> );
        }

        var hoursSpent,avgScore;
        if (this.state.userSummary) {
            hoursSpent = (this.state.userSummary.time_played / (1000 * 60 * 60));
            avgScore = this.state.userSummary.avg_score;
        }
        var jobification = 0; // TODO

        let lastLogin = this.state.lastLogin;

        return (
            <div className={`student dashboard ${this.props.className}`} role="main">
                <div className="welcome-message">
                    <span>{Strings['en'].dashboard.WELCOME_MESSAGE}</span>
                    <span className="user-name">{this.props.userInfo.display_name}</span>
                    <span className="avatar"></span>
                    { lastLogin ? 
                    <div className="last-login">
                        <label>{Strings['en'].dashboard.LAST_LOGIN}</label>
                        <span className="login-time"> { Moment(lastLogin.performed_at).format(HISTORY_DATE_FORMAT) }</span>
                    </div>
                    : null }
                </div>
            




                <div className="content content--wrap">
                    <div className="left-content">
                        <div className="current-course-list">
                            <h2 className="section-title">{Strings['en'].dashboard.YOUR_COURSES}</h2>
                            {currentCourses}
                        </div>
                        <div className="completed-course-list">
                            <h2 className="section-title">{Strings['en'].dashboard.COMPLETED_COURSES}</h2>
                            {completedCourses}
                        </div>
                    </div>
                    <div className="right-content">
                        <h2 className="section-title">{Strings['en'].dashboard.YOUR_PROGRESS}</h2>
                        <div className="progress-tracking narrow">
                            { this.state.userSummary ? 
                            <div className="progress-data">
                                <div className="progress-elem hours">
                                    <div className="progress-data-icon" aria-hidden>
                                        <i className="fa fa-clock-o" />
                                    </div>
                                    <div className="progress-value">{hoursSpent.toFixed(1) + 'h'}</div>
                                    <div className="progress-label">{Strings['en'].dashboard.HOURS_SPENT}</div>
                                </div>

                                { (typeof grandTotalStars === 'number') ?
                                <div className="progress-elem avg-score">
                                    <div className="progress-data-icon" aria-hidden>
                                        <i className="fa fa-star" />
                                    </div>
                                    {/*
                                    <div className="progress-value">{avgScore.toFixed(0) + '%'}</div>
                                    <div className="progress-label">{Strings['en'].dashboard.AVERAGE_SCORE}</div>
                                    */}
                                    <div className="progress-value">{grandTotalStars}</div>
                                    <div className="progress-label">{Strings['en'].dashboard.TOTAL_STARS}</div>
                                </div>
                                : null }

                                <div className="progress-elem jobification">
                                {/*
                                    <div className="progress-data-icon" aria-hidden>
                                        <i className="fa fa-briefcase" />
                                    </div>
                                    <div className="progress-value">{jobification}</div>
                                    <div className="progress-label">{Strings['en'].dashboard.JOBIFICATION_CARDS}</div>
                                */}
                                </div>
                            </div>
                            : null }
                        </div>
                        <ActionHistoryPanel
                            className="narrow"
                            userInfo={this.props.userInfo}
                            history={this.props.history}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

StudentHome.propTypes = propTypes;
StudentHome.defaultProps = defaultProps;

export default StudentHome;
